var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('home-slider',{attrs:{"services":_vm.services}}),_c('home-quote-steps',{attrs:{"quote-steps":_vm.quoteSteps}}),_c('home-call-me')],1)}
var staticRenderFns = []

export { render, staticRenderFns }